export default "__VITE_ASSET__284b6389__"